import { Box, SxProps } from "@mui/material";
import * as React from "react";

type RealTimeItemsLabelContainerProps = {
  sx?: SxProps;
};

const RealTimeItemsLabelContainer = (
  props: React.PropsWithChildren<RealTimeItemsLabelContainerProps>
) => {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        flexDirection: "column",
        ...props.sx,
      }}
    >
      {props.children}
    </Box>
  );
};

export default RealTimeItemsLabelContainer;
